import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCommon from './locales/en/common.json';
import huCommon from './locales/hu/common.json';
import deCommon from './locales/de/common.json';
import czCommon from './locales/cz/common.json';
import cnCommon from './locales/cn/common.json';

import enFaq from './locales/en/faq.json';
import huFaq from './locales/hu/faq.json';
import deFaq from './locales/de/faq.json';
import czFaq from './locales/cz/faq.json';
import cnFaq from './locales/cn/faq.json';

// Language resources
const resources = {
  en: {
    common: enCommon,
    faq: enFaq
  },
  hu: {
    common: huCommon,
    faq: huFaq
  },
  de: {
    common: deCommon,
    faq: deFaq
  },
  cz: {
    common: czCommon,
    faq: czFaq
  },
  cn: {
    common: cnCommon,
    faq: cnFaq
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'hu', // Default language if detection fails
    debug: process.env.NODE_ENV === 'development',

    // Common namespace used around the app
    ns: ['common', 'faq'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['navigator', 'htmlTag', 'cookie', 'localStorage', 'path', 'subdomain'],
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      cookieExpirationDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year
    }
  });

export default i18n;
